export const logUrls = {
  "/user": "کاربر",
  "/users": "کاربران",
  "/log": "رویدادنگاری",
  "/geo": "شهرها",
  "/ticket": "پشتیبانی",
  "/login": "ورود",
  "/setting": "تنظیمات اصلی",
  "/transaction": "تراکنشات",
  "/notification": "اعلان ها",
  "/upload": "آپلود",
  "/discount-code": "کدهای تخفیف",
  "/product": "محصولات",
  "/category": "دسته بندی ها",
  "/field": "فیلد ها",
  "/invoice": "فاکتور ها",
  "/faq": "سوالات متداول",
  "/bulk-sms": "پیامک های انبوه",
  "/renewal": "تمدید ها",
  "/payment": "پرداخت ها",
};
export const userRoleItems = ["ADMIN", "STAFF", "CUSTOMER"];
export const logMethodItems = ["POST", "DELETE", "PUT", "PATCH", "GET"];
export const uploadTypeItems = [
  "OTHERS",
  "AVATAR",
  "TICKETS",
  "DOCUMENTS",
  "PASS",
];
export const ticketTypeItems = ["OPEN", "ANSWERED", "CLOSED"];
export const transactionTypeItems = ["DEPOSIT", "WITHDRAWAL", "TRANSFER"];
export const createTransactionTypeItems = ["DEPOSIT", "WITHDRAWAL"];
export const notificationTypeItems = ["SUCCESS", "ERROR", "INFO", "WARNING"];
export const adminPermissions = {
  canUsers: "کاربران",
  canTickets: "پشتیبانی",
  canOrders: "سفارشات",
  canCategories: "دسته بندی ها",
  canFields: "فیلد ها",
  canProducts: "محصولات",
  canDiscountCodes: "کدهای تخفیف",
  canBulkSMSs: "پیامک های انبوه",
  canGeo: "شهر ها",
  canRenewals: "تمدیدها",
  canInvoices: "فاکتورها",
  canTransactions: "تراکنشات",
  canLogs: "رویدادنگاری",
  canPayments: "پرداخت ها",
  canSettings: "تنظیمات اصلی",
  canFAQs: "سوالات متداول",
};
export const sortItems = ["asc", "desc"];
export const lastDaysItems = [7, 15, 30, 90, 180, 365];
export const fieldTypeItems = [
  "TEXT",
  "NUMBER",
  "CHECKBOX",
  "TOGGLE",
  "DATE",
  "TIME",
  "SELECT",
  "RADIO",
  "TEXTAREA",
  "FILE",
];
export const productTypeItems = ["ONE_TIME", "CUSTOM", "SUBSCRIPTION"];
export const orderStatusItems = [
  "PENDING",
  "APPROVED",
  "IN_PROGRESS",
  "COMPLETED",
  "CANCELLED",
];
export const invoiceStatusItems = [
  "PENDING",
  "PROGRESS",
  "PAID",
  "CANCELLED",
  "EXPIRED",
];
export const paymentStatusItems = [
  "VERIFIED",
  "PAID",
  "IN_BANK",
  "FAILED",
  "REVERSED",
  "PENDING",
];
export const invoiceTypeItems = ["SYSTEM", "MANUAL"];
export const discountCodeTypeItems = ["PERCENTAGE", "FIXED"];
export const bulkSMSTypeItems = ["ALL", "CUSTOM"];
export const paymentGatewayItems = ["ZARINPAL"];
export const smsToken = {
  firstName: "{{firstName}}",
  lastName: "{{lastName}}",
  nationalNumber: "{{nationalNumber}}",
  address: "{{address}}",
};

//* Start Convert To Text
export const convertSortToText = (type) => {
  let result = "";
  switch (type) {
    case sortItems[0]:
      result = "صعودی";
      break;
    case sortItems[1]:
      result = "نزولی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToText = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "افزایش";
      break;
    case transactionTypeItems[1]:
      result = "کاهش";
      break;
    case transactionTypeItems[2]:
      result = "انتقال";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTicketTypeToText = (type) => {
  let result = "";
  switch (type) {
    case ticketTypeItems[0]:
      result = "باز";
      break;
    case ticketTypeItems[1]:
      result = "پاسخ داده شده";
      break;
    case ticketTypeItems[2]:
      result = "بسته";
      break;

    default:
      result = type;
      break;
  }
  return result;
};

export const convertRoleToText = (type) => {
  let result = "";
  switch (type) {
    case userRoleItems[0]:
      result = "ادمین";
      break;
    case userRoleItems[1]:
      result = "همکار";
      break;
    case userRoleItems[2]:
      result = "مشتری";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertLogUrlToText = (type) => {
  if (!type) return;

  const urls = Object.keys(logUrls);
  let result = type;
  for (const url of urls) {
    if (type.includes(url)) result = logUrls[url];
  }
  return result;
};
export const convertLogMethodToText = (type) => {
  let result = "";
  switch (type) {
    case logMethodItems[0]:
      result = "ایجاد";
      break;
    case logMethodItems[1]:
      result = "حذف";
      break;
    case logMethodItems[2]:
      result = "ویرایش";
      break;
    case logMethodItems[3]:
      result = "ویرایش جزئی";
      break;
    case logMethodItems[4]:
      result = "دریافت";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertFieldTypeToText = (type) => {
  let result = "";
  switch (type) {
    case fieldTypeItems[0]:
      result = "متن";
      break;
    case fieldTypeItems[1]:
      result = "عدد";
      break;
    case fieldTypeItems[2]:
      result = "چک باکس";
      break;
    case fieldTypeItems[3]:
      result = "تاگل";
      break;
    case fieldTypeItems[4]:
      result = "تاریخ";
      break;
    case fieldTypeItems[5]:
      result = "زمان";
      break;
    case fieldTypeItems[6]:
      result = "انتخابی";
      break;
    case fieldTypeItems[7]:
      result = "رادیوباتن";
      break;
    case fieldTypeItems[8]:
      result = "توضیحات";
      break;
    case fieldTypeItems[9]:
      result = "آپلود فایل";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertProductTypeToText = (type) => {
  let result = "";
  switch (type) {
    case productTypeItems[0]:
      result = "یکبار مصرف";
      break;
    case productTypeItems[1]:
      result = "سفارشی";
      break;
    case productTypeItems[2]:
      result = "اشتراکی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertOrderStatusToText = (type) => {
  let result = "";
  switch (type) {
    case orderStatusItems[0]:
      result = "درانتظار بررسی";
      break;
    case orderStatusItems[1]:
      result = "تایید شده";
      break;
    case orderStatusItems[2]:
      result = "درحال انجام";
      break;
    case orderStatusItems[3]:
      result = "انجام شده";
      break;
    case orderStatusItems[4]:
      result = "لغو شده";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertInvoiceStatusToText = (type) => {
  let result = "";
  switch (type) {
    case invoiceStatusItems[0]:
      result = "درانتظار پرداخت";
      break;
    case invoiceStatusItems[1]:
      result = "درحال پرداخت";
      break;
    case invoiceStatusItems[2]:
      result = "پرداخت شده";
      break;
    case invoiceStatusItems[3]:
      result = "لغو شده";
      break;
    case invoiceStatusItems[4]:
      result = "منقضی شده";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertPaymentStatusToText = (type) => {
  let result = "";
  switch (type) {
    case paymentStatusItems[0]:
      result = "وریفای شده";
      break;
    case paymentStatusItems[1]:
      result = "پرداخت شده (وریفای نشده)";
      break;
    case paymentStatusItems[2]:
      result = "درحال پرداخت";
      break;
    case paymentStatusItems[3]:
      result = "ناموفق (تکمیل نشده)";
      break;
    case paymentStatusItems[4]:
      result = "تراکنش ریورس شده";
      break;
    case paymentStatusItems[5]:
      result = "درحال بررسی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertInvoiceTypeToText = (type) => {
  let result = "";
  switch (type) {
    case invoiceTypeItems[0]:
      result = "سیستمی";
      break;
    case invoiceTypeItems[1]:
      result = "دستی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertDiscountCodeTypeToText = (type) => {
  let result = "";
  switch (type) {
    case discountCodeTypeItems[0]:
      result = "درصدی";
      break;
    case discountCodeTypeItems[1]:
      result = "ثابت";
      break;

    default:
      result = type;
      break;
  }
  return result;
};

export const convertBulkSMSTypeToText = (type) => {
  switch (type) {
    case bulkSMSTypeItems[0]:
      return "کاربران فعال";
    case bulkSMSTypeItems[1]:
      return "سفارشی";
    default:
      return type;
  }
};
export const convertPaymentGatewayToText = (type) => {
  switch (type) {
    case paymentGatewayItems[0]:
      return "زرین پال";
    default:
      return type;
  }
};
//* End Convert To Text

//* Start Convert To Color
export const convertTicketTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case ticketTypeItems[0]:
      result = "warning";
      break;
    case ticketTypeItems[1]:
      result = "success";
      break;
    case ticketTypeItems[2]:
      result = "danger";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "success";
      break;
    case transactionTypeItems[1]:
      result = "danger";
      break;
    case transactionTypeItems[2]:
      result = "primary";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertNotificationTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case notificationTypeItems[0]:
      result = "success";
      break;
    case notificationTypeItems[1]:
      result = "danger";
      break;
    case notificationTypeItems[2]:
      result = "info";
      break;
    case notificationTypeItems[3]:
      result = "warning";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertLogMethodToColor = (type) => {
  let result = "";
  switch (type) {
    case logMethodItems[0]:
      result = "success";
      break;
    case logMethodItems[1]:
      result = "danger";
      break;
    case logMethodItems[2]:
      result = "warning";
      break;
    case logMethodItems[3]:
      result = "info";
      break;
    case logMethodItems[4]:
      result = "primary";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertOrderStatusToColor = (type) => {
  let result = "";
  switch (type) {
    case orderStatusItems[0]:
      result = "warning";
      break;
    case orderStatusItems[1]:
      result = "info";
      break;
    case orderStatusItems[2]:
      result = "primary";
      break;
    case orderStatusItems[3]:
      result = "success";
      break;
    case orderStatusItems[4]:
      result = "danger";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertInvoiceStatusToColor = (type) => {
  let result = "";
  switch (type) {
    case invoiceStatusItems[0]:
      result = "warning";
      break;
    case invoiceStatusItems[1]:
      result = "info";
      break;
    case invoiceStatusItems[2]:
      result = "success";
      break;
    case invoiceStatusItems[3]:
      result = "danger";
      break;
    case invoiceStatusItems[4]:
      result = "danger";
      break;

    default:
      result = type;
      break;
  }
  return result;
};

export const convertPaymentStatusToColor = (type) => {
  let result = "";
  switch (type) {
    case paymentStatusItems[0]:
      result = "success";
      break;
    case paymentStatusItems[1]:
      result = "primary";
      break;
    case paymentStatusItems[2]:
      result = "info";
      break;
    case paymentStatusItems[3]:
      result = "danger";
      break;
    case paymentStatusItems[4]:
      result = "secondary";
      break;
    case paymentStatusItems[5]:
      result = "warning";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Color

//* Start Convert To Path
export const convertRoleToPath = (type) => {
  let result = "";
  switch (type) {
    case userRoleItems[0]:
      result = "admin";
      break;
    case userRoleItems[1]:
      result = "staff";
      break;
    case userRoleItems[2]:
      result = "customer";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Path

//* Start Convert To Icon
export const convertNotificationTypeToIcon = (type) => {
  let result = "";
  switch (type) {
    case notificationTypeItems[0]:
      result = "ix:success";
      break;
    case notificationTypeItems[1]:
      result = "mdi:error-outline";
      break;
    case notificationTypeItems[2]:
      result = "material-symbols:info-outline-rounded";
      break;
    case notificationTypeItems[3]:
      result = "cuida:warning-outline";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToIcon = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "ri-arrow-up-s-fill";
      break;
    case transactionTypeItems[1]:
      result = "ri-arrow-down-s-fill";
      break;
    case transactionTypeItems[2]:
      result = "ri-arrow-left-right-line";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Icon

//* Start Convert To Logo
export const convertPaymentGatewayToLogo = (type) => {
  switch (type) {
    case paymentGatewayItems[0]:
      return "/assets/images/payment/zarinpal.jpg";
    default:
      return type;
  }
};
//* End Convert To Logo

//* Start Data Exporter
export const exporterData = {
  discountCodes: {
    headers: [
      "عنوان",
      "کد تخفیف",
      "نوع",
      "درصد تخفیف",
      "مقدار تخفیف",
      "حداقل خرید",
      "حداکثر تخفیف",
      "یکبار مصرف",
      "محدودیت",
      "تاریخ انقضا",
      "توضیحات",
      "وضعیت فعال بودن",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
      "تعداد استفاده",
    ],
    keys: [
      "title",
      "code",
      "type",
      "percentage",
      "amount",
      "minPurchase",
      "maxDiscount",
      "singleUse",
      "limit",
      "expiredAt",
      "description",
      "isActive",
      "createdAt",
      "updatedAt",
      "uses",
    ],
    fileName: "discountCodes",
  },
  products: {
    headers: [
      "عنوان",
      "کد",
      "زیرمجموعه",
      "نوع",
      "قیمت",
      "دوره تمدید",
      "توضیحات",
      "وضعیت فعال بودن",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "title",
      "code",
      "category.title",
      "type",
      "price",
      "renewalPeriod",
      "description",
      "isActive",
      "createdAt",
      "updatedAt",
    ],
    fileName: "products",
  },
  users: {
    headers: [
      "نام",
      "نام خانوادگی",
      "کد ملی",
      "شماره موبایل",
      "ایمیل",
      "آدرس",
      "تایید ایمیل",
      "تایید شماره موبایل",
      "موجودی کیف پول",
      "نقش کاربر",
      "تایید شده",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "firstName",
      "lastName",
      "nationalNumber",
      "phoneNumber",
      "email",
      "address",
      "emailVerified",
      "phoneNumberVerified",
      "wallet",
      "role",
      "isConfirm",
      "createdAt",
      "updatedAt",
    ],
    fileName: "users",
  },
  invoices: {
    headers: [
      "کد تخفیف",
      "مقدار تخفیف",
      "شماره",
      "مقدار فاکتور",
      "نوع فاکتور",
      "وضعیت فاکتور",
      "توضیحات",
      "تاریخ انقضا",
      "نام کاربر",
      "نام خانوادگی کاربر",
      "شماره تماس کاربر",
      "ایمیل کاربر",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "discount.code",
      "discount.amount",
      "number",
      "amount",
      "type",
      "status",
      "description",
      "expiredAt",
      "user.firstName",
      "user.lastName",
      "user.phoneNumber",
      "user.email",
      "createdAt",
      "updatedAt",
    ],
    fileName: "invoices",
  },
  orders: {
    headers: [
      "عنوان محصول",
      "نوع محصول",
      "توضیحات محصول",
      "قیمت",
      "کد پیگیری",
      "وضعیت",
      "تاریخ تمدید",
      "شماره فاکتور",
      "مقدار فاکتور",
      "نوع فاکتور",
      "وضعیت فاکتور",
      "توضیحات فاکتور",
      "نام کاربر",
      "نام خانوادگی کاربر",
      "شماره تماس کاربر",
      "ایمیل کاربر",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "product.title",
      "product.type",
      "product.description",
      "product.price",
      "trackingCode",
      "status",
      "renewalDate",
      "invoice.number",
      "invoice.amount",
      "invoice.type",
      "invoice.status",
      "invoice.description",
      "user.firstName",
      "user.lastName",
      "user.phoneNumber",
      "user.email",
      "createdAt",
      "updatedAt",
    ],
    fileName: "orders",
  },
  payments: {
    headers: [
      "مقدار پرداخت",
      "کد پیگیری",
      "شماره کارت",
      "کد مرجع",
      "وضعیت",
      "درگاه پرداخت",
      "توضیحات",
      "تاریخ انقضا",
      "شماره فاکتور",
      "وضعیت فاکتور",
      "نام کاربر",
      "نام خانوادگی کاربر",
      "شماره تماس کاربر",
      "ایمیل کاربر",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "amount",
      "trackingCode",
      "cardPan",
      "refId",
      "status",
      "gateway",
      "description",
      "expiredAt",
      "invoice.number",
      "invoice.status",
      "user.firstName",
      "user.lastName",
      "user.phoneNumber",
      "user.email",
      "createdAt",
      "updatedAt",
    ],
    fileName: "payments",
  },
  transactions: {
    headers: [
      "نوع تراکنش",
      "مقدار تراکنش",
      "توضیحات",
      "کد پیگیری",
      "موجودی کیف پول",
      "نام کاربر",
      "نام خانوادگی کاربر",
      "شماره تماس کاربر",
      "ایمیل کاربر",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "type",
      "amount",
      "description",
      "trackingCode",
      "walletBalance",
      "user.firstName",
      "user.lastName",
      "user.phoneNumber",
      "user.email",
      "createdAt",
      "updatedAt",
    ],
    fileName: "transactions",
  },
  fields: {
    headers: [
      "نام",
      "برچسب",
      "نوع",
      "اجباری",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: ["name", "label", "type", "isRequired", "createdAt", "updatedAt"],
    fileName: "fields",
  },
  categories: {
    headers: [
      "عنوان",
      "توضیحات",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
      "وضعیت فعال",
    ],
    keys: ["title", "description", "createdAt", "updatedAt", "isActive"],
    fileName: "categories",
  },
  bulkSMSs: {
    headers: [
      "عنوان",
      "پیام",
      "نوع",
      "توضیحات",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: ["title", "message", "type", "description", "createdAt", "updatedAt"],
    fileName: "bulkSMSs",
  },
  logs: {
    headers: [
      "آدرس URL",
      "مسیر",
      "متد",
      "نام کاربر",
      "نام خانوادگی کاربر",
      "کد ملی",
      "شماره تماس کاربر",
      "ایمیل کاربر",
      "نقش کاربر",
      "تأیید کاربر",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "url",
      "pathname",
      "method",
      "user.firstName",
      "user.lastName",
      "user.nationalNumber",
      "user.phoneNumber",
      "user.email",
      "user.role",
      "user.isConfirm",
      "createdAt",
      "updatedAt",
    ],
    fileName: "logs",
  },
  geo: {
    headers: ["نام", "تاریخ ایجاد", "تاریخ آخرین ویرایش"],
    keys: ["name", "createdAt", "updatedAt"],
    fileName: "geo",
  },
};
//* End Data Exporter
